<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<el-page-header @back="goBack" content="代理商退费课程信息列表"></el-page-header>
			<el-divider content-position="left">代理商信息</el-divider>
			<div class="row-me row-center" v-if="agentInfo != null">
				<el-descriptions title="" colon="true" style="width: 100%;" :column = "4" border>
				  	<el-descriptions-item label="代理名称">{{agentInfo.lecturer_name}}</el-descriptions-item>
				  	<el-descriptions-item label="联系人">{{agentInfo.username}}</el-descriptions-item>
				  	<el-descriptions-item label="电话">{{agentInfo.phone}}</el-descriptions-item>
					<el-descriptions-item label="地区">{{agentInfo.region_text}} </el-descriptions-item>
				</el-descriptions>
			</div>
	 		<el-divider content-position="left">课时退费检索</el-divider>
			<div class="row-me row-center">
				<el-form-item label="备注说明"  class="margin-left30 margin-top20 width300">
					<el-input v-model="keyword" placeholder="备注说明"></el-input>
				</el-form-item>
				<el-form-item label="学生"  class="margin-left30 margin-top20 width300">
					<el-popover :width="480" placement="bottom-start"  trigger="focus">
						<template #reference>
							<el-input v-model="userKeyword" @input="userSystemSearchList()" :focus="userTableBoxOpen" placeholder="昵称/姓名/手机号"></el-input>
						</template>
						<el-table :data="userData" v-loading="userloading" v-model="userTableBox" size="large" :highlight-current-row="true" @row-click="userSelected">
							<el-table-column width="150" align="center" property="nickname" label="昵称" />
							<el-table-column width="150" align="center" property="name" label="姓名" />
							<el-table-column width="150" align="center" property="phone" label="手机号" />
						</el-table>
					</el-popover>
				</el-form-item>
				<el-form-item label="课程"  class="margin-left30 margin-top20 width300">
					<el-popover :width="480" placement="bottom-start"  trigger="focus">
						<template #reference>
							<el-input v-model="specialKeyword" @input="specialSystemSearchList()" :focus="specialTableBoxOpen" placeholder="课程名称"></el-input>
						</template>
						<el-table :data="specialData" v-loading="specialloading" v-model="specialTableBox" size="large" :highlight-current-row="true" @row-click="specialSelected">
							<el-table-column width="150" align="center" property="title" label="课程名称"></el-table-column>
							<el-table-column width="150" align="center" property="mold" label="课程类型">
								<template #default="scope">
									<el-tag v-if="scope.row.mold == 0" effect="dark" type="info">未知</el-tag>
									<el-tag v-if="scope.row.mold == 1" effect="dark" type="danger">主科</el-tag>
									<el-tag v-if="scope.row.mold == 2" effect="dark">副科</el-tag>
								</template>
							</el-table-column>
							<el-table-column width="150" align="center" property="TcSpecialSubInfo.name" label="课程分类"></el-table-column>
						</el-table>
					</el-popover>
				</el-form-item>
				<el-button class="margin-left20" type="primary" size="mini " @click="clickSearch" >搜索</el-button>
				<el-button size="mini " @click="clickClear" >重置</el-button>
			</div>
			<el-divider content-position="left">课时退费信息</el-divider>
			<div class="column-me flex1 overflow-auto">
				<div class="flex1 overflow-auto">
					<el-table :data="refundData" border v-loading="loading" stripe="true" size="medium" style="width: 100%" height="100%">
						<el-table-column prop="getTcUserInfo" label="学员信息" width="200" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="startTimeBox" v-if="scope.row.getTcUserInfo">昵称：{{scope.row.getTcUserInfo.nickname}}</div>
								<div class="startTimeBox margin-top10" v-if="scope.row.getTcUserInfo">姓名：{{scope.row.getTcUserInfo.name}}</div>
								<div class="startTimeBox margin-top10" v-if="scope.row.getTcUserInfo">手机号：{{scope.row.getTcUserInfo.phone}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="getTcSpecialInfo" label="课程信息" width="200" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="startTimeBox" v-if="scope.row.getTcSpecialInfo">名称：{{scope.row.getTcSpecialInfo.title}}</div>
								<div class="startTimeBox margin-top10" v-if="scope.row.getTcSpecialInfo.mold == 0">类型：<el-tag effect="dark" type="info">未知</el-tag></div>
								<div class="startTimeBox margin-top10" v-if="scope.row.getTcSpecialInfo.mold == 1">类型：<el-tag effect="dark" type="danger">主科</el-tag></div>
								<div class="startTimeBox margin-top10" v-if="scope.row.getTcSpecialInfo.mold == 2">类型：<el-tag effect="dark">副科</el-tag></div>
							</template>
						</el-table-column>
						<el-table-column  prop="special_progress" label="退课时百分比" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-progress :stroke-width="10" :percentage="scope.row.special_progress"></el-progress>
							</template>
						</el-table-column>
						<el-table-column prop="remark" label="退费备注说明" width="500" align="center" show-overflow-tooltip></el-table-column>
						
						<el-table-column prop="add_time" label="添加日期" width="150" align="center" show-overflow-tooltip></el-table-column>
					</el-table>
				</div>
				<div class="margin-top20">
					<el-pagination @current-change="handleCurrentChange" background :current-page.sync="pageNo"
			             layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {Plus,Search} from "@element-plus/icons";
export default {
	components: {Plus,Search},
	data() {
		return {
			id:'',
			keyword: '',
			pageNo:1,
			total:0,
			loading:false,
			refundData:null,
			
			agent_id:0,
			agentInfo:null,
			
			user_id:0,
			userKeyword:'',
			userData:null,
			userTableBox:false,
			userloading:false,
			
			special_id:0,
			specialKeyword:'',
			specialData:null,
			specialTableBox:false,
			specialloading:false,
		}
	},
	// 侦听器
	watch: {},
	// 计算属性
	computed: {
		Search() {
			return Search
		}
	},
	// html加载完成之前
	created() {
		this.agent_id = this.$route.query.id;
		this.getData();
		this.getAgentInfo();
	},
	// html加载完成后执行。
	mounted() {
		//this.agentSystemSearchList();
		this.userSystemSearchList();
		this.specialSystemSearchList();
		
	},
	// 事件方法执行
	methods: {
		goBack(){
			this.$router.go(-1)
		},
		clickSearch(){
			this.getData();
		},
		clickClear(){
			this.agent_id = 0;
			this.agentKeyword = '';
			this.user_id = 0;
			this.userKeyword = '';
			this.special_id = 0;
			this.specialKeyword = '';
			this.getData();
			this.userSystemSearchList();
			this.specialSystemSearchList();
		},
		handleCurrentChange(){
			this.pageNo = pageNo
			this.specialRefundSearchList()
		},
		//==================================代理检索======================================
		//代理检索table数据
		agentSystemSearchList(){
			this.agentloading = true;
			this.$post('/admin/agentSystemSearchList', {
				keyword: this.agentKeyword,
			}).then((res) => {
				if (res) {
					this.agentData = res.data;
					this.agentloading = false;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//代理检索选中
		agentSelected(row){
			this.agentKeyword = row.lecturer_name;
			this.agent_id = row.id;
			this.agentTableBox = false;
			this.getData();
		},
		agentTableBoxOpen(){
			this.agentTableBox = true;
		},
		//==================================学员检索======================================
		//学员检索table数据
		userSystemSearchList(){
			this.userloading = true;
			this.$post('/admin/userSystemSearchList', {
				keyword: this.userKeyword,
			}).then((res) => {
				if (res) {
					this.userData = res.data;
					this.userloading = false;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//学员检索选中
		userSelected(row){
			this.userKeyword = row.nickname;
			this.user_id = row.id;
			this.userTableBox = false;
			this.getData();
		},
		userTableBoxOpen(){
			this.userTableBox = true;
		},
		//==================================课程检索======================================
		//课程检索table数据
		specialSystemSearchList(){
			this.specialloading = true;
			this.$post('/admin/specialSystemSearchList', {
				keyword: this.specialKeyword,
			}).then((res) => {
				if (res) {
					this.specialData = res.data;
					this.specialloading = false;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//课程检索选中
		specialSelected(row){
			this.specialKeyword = row.title;
			this.special_id = row.id;
			this.specialTableBox = false;
			this.getData();
		},
		specialTableBoxOpen(){
			this.specialTableBox = true;
		},
		//==================================课程退费=====================================
		getData(){
			this.$post('/admin/specialRefundSearchList', {
				keyword:this.keyword,
				agent_id: this.agent_id,
				user_id: this.user_id,
				special_id: this.special_id,
				page: this.pageNo
			}).then((res) => {
				if (res) {
					this.refundData = res.data.listInfo;
					this.total = res.data.all_info_num
					this.loading = false;
					console.log(this.refundData);
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//代理基础信息获取
		getAgentInfo(){
			this.$post('/admin/agentInfo', {
				id:this.agent_id
			}).then((res) => {
				if (res) {
					this.agentInfo = res.data;
				}
			}).catch((error) => {
				console.log(error)
			})
		}
	},
}
</script>

<style lang="scss" scoped>
.userList {
  height: 100%;

  .img-header {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .el-date-editor .el-input__inner {
    font-size: 14px !important;
  }
}
</style>
